import React from "react"
import PropTypes from "prop-types"

import BadgeExplainerModal from './BadgeExplainerModal'

class BadgeIcon extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      openExplainer: false
    }

    this.openBadge = this.openBadge.bind(this)
  }

  openBadge() {
    this.setState({
      openExplainer: !this.state.openExplainer
    })
  }

  render() {
    if(this.state.openExplainer === true) {
      return(
        <BadgeExplainerModal badge={this.props.badge} closeModal={this.openBadge} closeIcon={this.props.closeIcon}/>
      )
    }
    return(
      <div style={{height: 100, alignItems: 'center', display: 'inline-block'}}>
      <button onClick={this.openBadge.bind(this)} style={{padding: 0}}>
        <img
          src={this.props.badge.image_url}
          style={{
            height: 75,
            width: 75,
            marginTop: 7,
            zIndex: 2,
            opacity: this.props.badgeEarned ? 1 : .3,
            cursor: 'pointer'
          }}
        />
      </button>
      </div>
    )
  }
}

export default BadgeIcon
